export {useGridRowGroup, type GridRowGroupAria} from '../../../src/grid/useGridRowGroup';
